<template>
  <div class="vehicle-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        :rules="queryRules"
        size="small"
        class="query-middle"
      >
        <el-form-item label="车牌号：" prop="PlateNumber">
          <el-input v-model="query.PlateNumber"></el-input>
        </el-form-item>
        <el-form-item label="创建时间：" prop="StartTime" style="margin-left:20px;">
          <el-date-picker v-model="query.StartTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="—" prop="EndTime">
          <el-date-picker v-model="query.EndTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 200px"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left:20px;">
          <el-button type="primary" icon="el-icon-search" @click="loadBusList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-circle-close" @click="clearQuery('queryForm')">清除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span>
            <i class="el-icon-folder-opened"></i>车辆列表
          </span>
          <el-button-group>
            <el-button icon="el-icon-circle-plus-outline" type="primary" size="mini" @click="add">新增</el-button>
          </el-button-group>
        </div>
        <div>
          <el-dialog
            title="添加车辆"
            :visible.sync="adddialogVisible"
            :close-on-click-modal="false"
            width="40%"
            @open="resetForm('postForm')"
          >
            <el-form
              :model="addForm"
              status-icon
              :rules="addformrules"
              ref="postForm"
              label-width="70px"
            >
              <el-form-item label="车牌号" prop="PlateNumber">
                <el-input v-model="addForm.PlateNumber"></el-input>
              </el-form-item>
              <el-form-item label="人数" prop="TotalPassenger">
                <el-input v-model="addForm.TotalPassenger"></el-input>
              </el-form-item>
              <el-form-item label="类型" prop="VehicleType">
                <el-input v-model="addForm.VehicleType"></el-input>
              </el-form-item>
              <el-form-item label="照片">
                <el-upload
                  v-if="adddialogVisible"
                  ref="uploadAdd"
                  action="/api/co/Attachment/UploadAttachment"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccessAdd"
                  :on-remove="uploadRemoveAdd"
                  :on-error="uploadError"
                  list-type="picture"
                  :limit="1"
                  :headers="{
            AttachmentType:'bus-pic',
              sessionId: voucher.sessionId,
              'X-Token':voucher.token,
             }"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip">只能上传图片文件，且不超过10MB,数量为1</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="adddialogVisible = false">取 消</el-button>

              <el-button type="primary" @click="postModel('postForm')">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <div class="left-table">
          <el-table :data="tableData" height="753px" border style="width:100%" v-loading="loadintTable">
            <el-table-column type="selection" min-width="10" align="center"></el-table-column>
            <el-table-column label="车牌号" prop="PlateNumber" min-width="180" align="center"></el-table-column>
            <el-table-column label="汽车类型" prop="VehicleType" min-width="100" align="center"></el-table-column>
            <el-table-column label="创建时间" prop="ApplyTime" min-width="180" align="center">
                <template slot-scope="scope">
                <p>{{scope.row.ApplyTime | dateFormat}}</p>
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="Status" min-width="100" align="center"  fixed="right">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | statusTypeFormat(normalStatus)"
                  effect="dark"
                  size="small"
                >{{scope.row.Status | status2Format(normalStatus)}}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="190" align="center" fixed="right">
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-button-group>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="lookBus(scope.row.Id)"
                    >查看</el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeBus(scope.row.Id,1)"
                      v-if="scope.row.Status === 0"
                    >禁用</el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeBus(scope.row.Id,0)"
                      v-if="scope.row.Status === 1"
                    >启用</el-button>
                    <el-popconfirm title="确认删除吗？" v-on:onConfirm="changeBus(scope.row.Id,-1)" v-if="scope.row.Status!=2">
                      <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </el-button-group>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
           <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="total"
            :page-size="query.PageSize"
            :page-sizes="[10,20,50]"
            :current-page.sync="query.PageIndex"
            v-on:size-change="handleSizeChange"
            v-on:current-change="handleCurrentPageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span>
            <i class="el-icon-document"></i> 查看
          </span>
          <el-button-group>
            <el-button type="warning" v-show="flag === 1" size="mini" @click="edit">编辑</el-button>
            <el-button type="success" v-show="flag===2" size="mini" @click="save">保存</el-button>
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag === 1" v-loading="loadingLook">
            <thead>
              <tr>
                <th colspan="2">车辆信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>车牌号</td>
                <td>{{detail. PlateNumber}}</td>
              </tr>
              <tr>
                <td>载客人数</td>
                <td>{{detail.TotalPassenger}}</td>
              </tr>
              <tr>
                <td>车辆类型</td>
                <td>{{detail.VehicleType}}</td>
              </tr>
              <!-- <tr>
                <td>车辆状态</td>
                <td>{{detail.Status | status2Format}}</td>
              </tr> -->
              <tr>
                <td :rowspan="showPicList.length">车辆照片</td>
                <td>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="pictureDialog = true"
                    v-if="showPicList.length > 0"
                  >查看照片</el-button>
                  <span v-else>暂无照片</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="input-form" v-show="flag === 2">
            <thead>
              <tr>
                <th colspan="2">车辆信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>车牌号</td>
                <td>
                  <el-input v-model="detail.PlateNumber" placeholder="请输入车牌号"></el-input>
                </td>
              </tr>
              <tr>
                <td>载客人数</td>
                <td>
                  <el-input v-model="detail.TotalPassenger" placeholder="请输入载客人数"></el-input>
                </td>
              </tr>
              <tr>
                <td>车辆类型</td>
                <td>
                   <el-input v-model="detail.VehicleType" placeholder="请输入车辆类型"></el-input>
                  <!-- <el-select v-model="detail.VehicleType" placeholder="请输入车辆类型">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select> -->
                </td>
              </tr>
              <!-- <tr>
                <td>车辆状态</td>
                <td>
                  <el-select v-model="detail.Status">
                    <el-option
                      v-for="item in normalStatus"
                      :key="item.key"
                      :label="item.val"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </td>
              </tr> -->
              <tr>
                <td>车辆照片</td>
                <td>
                  <el-upload
                    ref="uploadEdit"
                    action="/api/co/Attachment/UploadAttachment"
                    :before-upload="uploadBefore"
                    :on-success="uploadSuccessUpdate"
                    :on-remove="uploadRemove"
                    :on-error="uploadError"
                    :file-list="showPicList"
                    list-type="picture"
                    :limit="1"
                    :headers="{
               AttachmentType:'scenic-pic',
                      BelongIndex: detail.Id,
                      sessionId: voucher.sessionId,
                      'X-Token':voucher.token,
                      }"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip">只能上传图片文件，且不超过10MB，数量为1</div>
                  </el-upload>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-dialog
          title="车辆照片"
          :visible.sync="pictureDialog"
          width="50%"
          center
          class="picture-dialog"
        >
          <el-carousel indicator-position="outside" :loop="false">
            <el-carousel-item v-for="picId in showPicList" :key="picId.Id">
              <el-image :src="complementPicUrl(picId.Id)" fit="scale-down" style="height: 100%">
                <div slot="placeholder">加载中....</div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { status2Format, statusTypeFormat } from "@/filters/filters";
import {  keyToVal,dateFormat } from "@/filters/filters";
import BUS from "@/api/bus";
import Attachment from "@/api/common";
import { mapState } from "vuex";
export default {
  name: "VehicleManage",
  inject: ["voucher", "complementPicUrl"],
  data() {
    return {
      loadintTable:false,
      loadingLook:false,
      query: {
        ticketId: "",
        StartTime: "",
        EndTime: "",
        PlateNumber: "",

        Status: "",
        VehicleType: "",
        PageSize: 10,
        PageIndex: 1,
      },
      showPicList: [],
      pictureDialog: false,
      adddialogVisible: false,
      total: 0,
      tableData: [],
      detail: {
        PlateNumber: "",
        VehicleType: "",
        TotalPassenger: "",
        ApplyTime:"",
        type: "",
        picUrl: "",
        Status: "",
        Images:[]
      },
      form: {
        PlateNumber: "",
        TotalPassenger: "",
        VehicleType: "",
        ApplyTime:"",
        picUrl: "",
        Status: "",
      },
      options: [{ label: "大巴", value: "1" }],

      queryRules: {},
      flag: 0, //0初始化 1查看状态（编辑显示） 2编辑状态（保存显示）
      //添加数据
      addForm: {
        PlateNumber: "",
        TotalPassenger: "",
        VehicleType: "",
        Images: [],
      },
      addformrules: {
        PlateNumber: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
        ],
        TotalPassenger: [
          { required: true, message: "请输入车辆人数", trigger: "blur" },
        ],
        VehicleType: [
          { required: true, message: "请输入类型", trigger: "blur" },
        ],
      },
    };
  },
  filters: {
    status2Format,
    statusTypeFormat,
     keyToVal,
    dateFormat,
  },
  computed: {
    ...mapState("common", ["genderMap"]),
    ...mapState("common", ["normalStatus"]),
  },
  methods: {
   //关闭弹窗后清空表单
    resetForm(form) {
      this.$refs[form].clearValidate();
      this.$refs[form].resetFields();
      this.addForm.Images = []; //清空
           this.showPicList=[]
    },
    clearQuery(formName) {
      if (formName === "queryForm") {
        this.query = {
          ProjectName: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };
      } else if (formName === "postForm") {
        this.form = {
          PlateNumber: "",
        TotalPassenger: "",
        VehicleType: "",
        ApplyTime:"",
        picUrl: "",
        Status: "",
        };
      }
      this.loadBusList();
    },

    //查询
    loadBusList() {
      this.loadintTable=true;
      BUS.loadBusList(this.query).then((res) => {
        this.total = res.content.Total;
        this.tableData = res.content.OnePageData;
        this.loadintTable=false;
      });
    },
    //通过id查询
    lookBus(Id) {
      const param = {
        Id,
      };
      this.loadingLook=true;
      BUS.lookBus(param).then((res) => {
        if (res.status === "success") {
          this.detail = res.content.data;
          this.showPicList = res.content.BusImages.map((v) => {
            let data = {
              Id: v.Id,
              name: v.FileName,
              url: this.complementPicUrl(v.Id),
            };

            return data;
          });

          this.flag = 1;
        } else {
          this.$message.error(res.msg);
        }
        this.loadingLook=false;
      });
    },
    //添加
    postModel(formName) {
      this.$refs[formName].validate((success) => {
        if (success) {
          BUS.addBus(this.addForm).then((res) => {
            if (res.status === "success") {
              this.adddialogVisible = false;
              this.$message.success("添加成功");
              this.loadBusList();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请补全信息");
        }
      });
    },
    // 禁用 删除
    changeBus(Id, status) {
      switch (status) {
        case 0:
          BUS.enableBus({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("修改成功!");
              this.loadBusList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        case 1:
          BUS.disableBus({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("禁用成功!");
              this.loadBusList();
            } else {
               this.$message.error(res.msg);
            }
          });
          break;
        case -1:
          BUS.deleteBus({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("删除成功!");
              this.loadBusList();
            } else {
               this.$message.error(res.msg);
            }
          });
          break;
        default:
          break;
      }
      
    },
    //修改保存
    save() {
      this.detail.Images = this.showPicList.map(v=>v.Id);
      BUS.updateBus(this.detail).then((res) => {
        if (res.status === "success") {
          this.$message.success("修改成功");
          this.flag = 0; //修改成功，重新获取数据，修改flag
          this.loadBusList();
        } else {
          this.$message.error(res.msg);
        }
      });
      this.loadBusList();
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
         
          return false;
        }
      });
    },
  
    edit() {
      this.flag = 2;
    },
    remove(id) {
     
    },
    add() {
      (this.adddialogVisible = true);
      this.addForm={
         PlateNumber: "",
        TotalPassenger: "",
        VehicleType: "",
        Images: [],
      }
      this.showPicList = []
    },

    handleSizeChange(val) {
      this.query.PageSize = val;
    },
    handleCurrentPageChange(val) {
      this.query.PageIndex = val;
    },
    //图片上传之前判断
    uploadBefore(file) {
      let fileType = file.type,
        isImage = fileType.indexOf("image") != -1,
        isBig = file.size <= 1024 * 1024 * 10;
      if (!file) {
        this.$refs.upload.onError();
        this.$message.error("上传为空！");
        return false;
      }
      if (!isImage) {
        this.$refs.upload.onError();
        this.$message.error("只能上传图片！");
        return false;
      }
      if (!isBig) {
        this.$refs.upload.onError();
        this.$message.error("图片大小不能超过10MB！");
        return false;
      }
      return true;
    },
    //图片上传成功之后回传
    uploadSuccessAdd(res) {
      if (res.status === "success") {
        this.$message.success("图片上传成功！");
        this.addForm.Images.push(res.content);
      } else {
      this.$message.error("上传失败！");
      }
    },
    
    uploadSuccessUpdate(res) {
      if (res.status === "success") {
        this.$message.success("图片上传成功！");
        this.showPicList.push({Id:res.content,url:this.complementPicUrl(res.content)});
      } else {
      this.$message.error("上传失败！");
      }
    },
    
    //图片上传失败
    uploadError() {
      this.$message.error("上传失败！");
    },
    //图片移除上传
    uploadRemoveAdd(file) {
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: file.response.content,
      }).then((res) => {
        if (res.status === "success") {
          const index = this.addForm.Images.indexOf(file.response.content);
          if (index !== -1) {
            this.addForm.Images = this.addForm.Images.slice(index, 1);
          }
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    uploadRemove(file) {
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: file.Id,
      }).then((res) => {
        if (res.status === "success") {
          this.showPicList.pop();
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      });
    },
  },
  created() {
    this.loadBusList();
  },
  watch: {
    "query.PageSize": function () {
      this.loadBusList();
    },
    "query.PageIndex": function () {
      this.loadBusList();
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.main-left {
  width: 40%;

  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.main-right {
min-width: 600px;
  flex: 1;
}
.right-table {
  padding: 20px;
  min-width: 500px;

}
.input-form {
  width: 65%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-select {
  width: 100%;
}
.input-form /deep/ .el-input__inner {
  border: none;
  width: 100%;
}
.vehicle-manage /deep/.el-carousel__container{
  text-align: center;
}
</style>
